// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lfj3","badges":"styles_badges__iO9wv"};